// Bridge between the axios interceptor and the authenticator-code dialog
// (component/ConfirmCodeDialog.js). The dialog registers itself on mount;
// requestConfirmCode() opens it and resolves with { code }, or null when
// the admin cancels.
let openDialog = null;

export const registerConfirmCodeDialog = (open) => {
  openDialog = open;
  return () => {
    if (openDialog === open) openDialog = null;
  };
};

export const requestConfirmCode = (message) =>
  openDialog ? openDialog(message) : Promise.resolve(null);

export const CONFIRM_CODE_HEADER = "X-Admin-Confirm-Code";
